import { GlFormGroup, GlFormInput } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import axios from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/axios_utils.js?vue3';
import { visitUrl } from '~/lib/utils/url_utility';
import { __ } from '~/locale';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import CommitChangesModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/commit_changes_modal.vue?vue3';
const DIR_LABEL = __('Directory name');
const COMMIT_MESSAGE = __('Add new directory');
export default {
    name: 'NewDirectoryModal',
    components: {
        GlFormGroup,
        GlFormInput,
        CommitChangesModal
    },
    mixins: [
        glListenersMixin
    ],
    i18n: {
        DIR_LABEL,
        COMMIT_MESSAGE
    },
    props: {
        modalId: {
            type: String,
            required: true
        },
        targetBranch: {
            type: String,
            required: true
        },
        originalBranch: {
            type: String,
            required: true
        },
        path: {
            type: String,
            required: true
        },
        canPushCode: {
            type: Boolean,
            required: true
        },
        canPushToBranch: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            dir: null,
            loading: false,
            error: null
        };
    },
    computed: {
        isValid () {
            return Boolean(this.dir);
        }
    },
    methods: {
        submitForm (formData) {
            this.loading = true;
            this.error = null;
            formData.append('dir_name', this.dir);
            if (!formData.has('branch_name')) {
                formData.append('branch_name', this.originalBranch);
            }
            return axios.post(this.path, formData).then((response)=>{
                visitUrl(response.data.filePath);
            }).catch(({ response })=>{
                this.error = response?.data?.error;
            }).finally(()=>{
                this.loading = false;
            });
        }
    }
};
